import { create } from 'zustand';

interface VoiceState {
  isOverlayRequested: boolean;
  requestOverlay: () => void;
  clearRequest: () => void;
}

export const useVoiceStore = create<VoiceState>((set) => ({
  isOverlayRequested: false,
  requestOverlay: () => set({ isOverlayRequested: true }),
  clearRequest: () => set({ isOverlayRequested: false }),
}));
